import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportDelinquentAccount from "../reports/ReportDelinquentAccount";


function DelinquentAccountReport() {
    return (
        <>
            <NavMain slug="delinquent-account-report" parent="3" />
            <HeaderMain slug="delinquent-account-report" />
            <div className="main-content">
                <ReportDelinquentAccount />
            </div>
        </>
    );
}

export default DelinquentAccountReport;